import React, { useState, useEffect } from 'react';
import { Cookie, X } from 'lucide-react';
import { showCookiePreferences } from '../lib/cookieConsent';

/**
 * Persistent floating button to re-open cookie preferences at any time.
 * Sits in the bottom-right corner above/beside the chat widget.
 */
export const CookiePreferencesButton = () => {
  const [isHidden, setIsHidden] = useState(false);

  useEffect(() => {
    const handleShow = () => setIsHidden(false);
    window.addEventListener('show-cookie-button', handleShow);
    return () => window.removeEventListener('show-cookie-button', handleShow);
  }, []);

  if (isHidden) return null;

  return (
    <div className="fixed bottom-4 left-4 z-[9999] group">
      {/* Botón sutil de ocultar, visible al hacer hover */}
      <button
        type="button"
        onClick={(e) => {
          e.stopPropagation();
          setIsHidden(true);
        }}
        className="absolute -top-1 -right-1 bg-red-500 hover:bg-red-600 text-white rounded-full p-0.5 w-4 h-4 text-[9px] flex items-center justify-center border border-white/20 shadow-md opacity-0 group-hover:opacity-100 transition-opacity duration-200 z-[10000]"
        title="Ocultar preferencias de cookies"
        aria-label="Ocultar botón de cookies"
      >
        <X className="w-2.5 h-2.5" />
      </button>

      <button
        type="button"
        onClick={showCookiePreferences}
        aria-label="Ajustes de privacidad y cookies"
        data-testid="cookie-preferences-floating-button"
        className="w-10 h-10 rounded-full flex items-center justify-center shadow-[0_8px_24px_rgba(27,42,74,0.45)] border-2 border-[#D4AF37] bg-gradient-to-br from-[#1B2A4A] to-[#2a3b66] hover:scale-105 active:scale-95 transition-transform"
        title="Ajustes de privacidad"
      >
        <Cookie className="w-5 h-5 text-[#D4AF37]" strokeWidth={2.25} />
      </button>
    </div>
  );
};

export default CookiePreferencesButton;
